// extracted by mini-css-extract-plugin
module.exports = {"container":"FJPreviewTips_container__WwgBZ","active":"FJPreviewTips_active__3otGl","text":"FJPreviewTips_text__3Gm2G"};